<template>
  <v-container
    class="testimonials"
    fluid
    v-if="testimonials.length"
  >
    <h5 class="pt-4 pb-3">Testimonials</h5>
    <v-carousel light :height="carouselHeight" hide-delimiters>
      <template v-slot:prev="{ on, attrs }">
        <v-btn
          icon
          large
          v-bind="attrs"
          v-on="on"
        ><v-icon>mdi-chevron-left</v-icon></v-btn>
      </template>
      <template v-slot:next="{ on, attrs }">
        <v-btn
          icon
          large
          v-bind="attrs"
          v-on="on"
        ><v-icon>mdi-chevron-right</v-icon></v-btn>
      </template>
      <v-carousel-item
        class="text-center"
        v-for="(testimonial,i) in testimonials"
        :key="i"
      >
        <v-row class="fill-height" align="center" justify="center">
          <v-col class="quotes" :style="quotesStyle">
            <p class="text-center">"{{testimonial.quote}}"</p>
            <span>{{testimonial.reference}}</span>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
import {
  VBtn,
  VCarousel,
  VCarouselItem,
  VCol,
  VContainer,
  VIcon,
  VRow,
} from 'vuetify/lib'
import {db} from '@/plugins/firebase'

const testimonialsCollection = db.collection('testimonials')

export default {
  components: {
    VBtn,
    VCarousel,
    VCarouselItem,
    VCol,
    VContainer,
    VIcon,
    VRow,
  },
  computed: {
    carouselHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '290px'
        case 'sm': return '150px'
        case 'md': return '130px'
        case 'lg': return '100px'
        case 'xl': return '110px'
      }
      return '110px'
    },
    quotesStyle() {
      return {
        'margin': this.$vuetify.breakpoint.xsOnly ? '0px 60px' : '0px 100px'
      }
    }
  },
  data: () => ({
    testimonials: []
  }),
  mounted() {
    testimonialsCollection.get().then((querySnapshot) => {
      if (!querySnapshot.empty) {

        this.testimonials = querySnapshot.docs
          .map((doc) => doc.data())
          .filter((testimonial) => !testimonial.archived)
          .filter((testimonial) => {
            if (!this.filter) {
              return testimonial
            }

            if (testimonial.service == this.filter) {
              return testimonial
            }
          })
      }
    })
  },
  props: {
    filter: String,
  }
}
</script>

<style lang="scss">
.testimonials {
  background: rgba($color: #697b5e, $alpha: 0.3);

  h5 {
    text-align: center;
  }

  .v-window {
    box-shadow: none;

    .v-window__next i,
    .v-window__prev i {
      color: black;
    }
  }

  .quotes {
    p {
      font-size: 15px;
      font-style: italic;
      margin-bottom: 10px;
      text-align: center;
    }

    span {
      text-transform: uppercase;
    }
  }
}
</style>
